/* eslint-disable no-case-declarations */
import { ICustomeDevcie } from "@/types/device";
import { createContext, useContext } from "react";

export const localDevice: ICustomeDevcie = {
  key: "local",
  name: "本地音频",
  code: "",
  type: "computer",
};

interface UpdateMicListAction {
  type: "updateMicList";
  payload: MediaDeviceInfo[];
}

interface UpdateDeviceListAction {
  type: "updateDeviceList";
  payload: ICustomeDevcie[];
}

interface UpdateCurrentMicAction {
  type: "updateCurrentMic";
  payload: MediaDeviceInfo | undefined;
}

interface UpdateCurrentDeviceAction {
  type: "updateCurrentDevice";
  payload: ICustomeDevcie | undefined;
}

interface UpdateMicModalAction {
  type: "updateMicModal";
  payload: boolean;
}

interface UpdateConnectModalAction {
  type: "updateConnectModal";
  payload: boolean;
}

export type MicSwitcherAction =
  | UpdateMicListAction
  | UpdateDeviceListAction
  | UpdateCurrentMicAction
  | UpdateCurrentDeviceAction
  | UpdateMicModalAction
  | UpdateConnectModalAction;

export interface MicSwitcherState {
  showMicModal: boolean;
  showConnectModal: boolean;
  micList: MediaDeviceInfo[];
  deviceList: ICustomeDevcie[];
  displayDevices?: ICustomeDevcie[];
  currentMic?: MediaDeviceInfo;
  currentDevice?: ICustomeDevcie;
}

export const micSwitcherReducer = (
  state: MicSwitcherState,
  action: MicSwitcherAction
): MicSwitcherState => {
  switch (action.type) {
    case "updateMicList":
      return { ...state, micList: action.payload as MediaDeviceInfo[] };
    case "updateDeviceList":
      const deviceList = action.payload as ICustomeDevcie[];
      const displayDevices =
        state.currentDevice && state.currentDevice.type === "ifpd"
          ? [deviceList.filter((d) => d.code !== state.currentDevice?.code)[0]]
          : deviceList.slice(0, 2);
      return { ...state, deviceList: deviceList, displayDevices };
    case "updateCurrentMic":
      return { ...state, currentMic: action.payload as MediaDeviceInfo };
    case "updateCurrentDevice":
      const currentDevice = action.payload as ICustomeDevcie;
      if (currentDevice?.type === "ifpd") {
        const displayDevices = [
          state.deviceList.filter(
            (d) => d.code !== currentDevice?.code
          )[0],
        ];
        return { ...state, currentDevice, displayDevices: displayDevices };
      } else {
        const displayDevices = state.deviceList.slice(0, 2);
        console.log('updateCurrentDevice', currentDevice, displayDevices);
        return { ...state, currentDevice: currentDevice, displayDevices };
      }
    case "updateMicModal":
      return { ...state, showMicModal: action.payload as boolean };
    case "updateConnectModal":
      return { ...state, showConnectModal: action.payload as boolean };
    default:
      return state;
  }
};

export const initialState: MicSwitcherState = {
  showMicModal: false,
  showConnectModal: false,
  micList: [],
  deviceList: [],
  currentDevice: localDevice,
};

export interface MicSwitcherContextType {
  state: MicSwitcherState;
  dispatch: (action: MicSwitcherAction) => void;
}

const context = createContext<MicSwitcherContextType | undefined>(undefined);

export const useMicSwitcherContext = () => {
  const contextValue = useContext(context);
  if (!contextValue) {
    throw new Error(
      "useMicSwitcherContext must be used within a MicSwitcherProvider"
    );
  }
  return contextValue;
};

export const MicSwitcherProvider = context.Provider;
